import { Navigate, RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router';

import routeConfig from 'app/config/routes';

import Approvals from './Approvals';

export const approvalsRouter: RouteObject = {
  path: routeConfig.approvals.path,
  element: (
    <>
      <Outlet />
    </>
  ),
  children: [
    {
      index: true,
      element: <Navigate to={routeConfig.approvals.routes.posts.path} />,
    },
    {
      path: routeConfig.approvals.routes.posts.path,
      element: <Approvals />,
    },
  ],
};
